// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,  
 // baseUrl:'http://localhost:8088/APIApp',
  // baseUrl : 'https://66eq22k3y2.execute-api.us-east-2.amazonaws.com',
  baseUrl : 'https://qdvzcq02z7.execute-api.us-east-2.amazonaws.com',
  UserPoolId: 'us-east-1_LlpoBavMN', // Your user pool id here
  ClientId: '2rvlbnmj7vseb4thomloq88jr8' // Your client id here
   
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
